<template>
  <div class="container-custom">
    <Breadscrumbs
      :links="[
        { name: 'Investor FAQ',
          to: {
            name: 'InvestorFAQList'
          }
        },
        { name: 'Edit',
          to: {
            name: 'InvestorFAQEdit',
            params: {
              id: $route.params.id,
            }
          },
        },
      ]"
    ></Breadscrumbs>
    <div class="page-actions">
      <h2>編輯Investor FAQ</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        取消
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        儲存
      </button>
    </div>
    <InvestorFAQCreateEdit></InvestorFAQCreateEdit>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import InvestorFAQCreateEdit from '@/views/I-1__IR-InvestorFAQ/c/InvestorFAQCreateEdit.vue';

export default {
  components: {
    Breadscrumbs,
    InvestorFAQCreateEdit,
  },
  async created() {
    if (this.$route.params.id) {
      await this.getShareholderFaq(this.$route.params.id);
    }
  },
  computed: {
    ...mapState('shareholderFaq', ['shareholderFaq']),
  },
  methods: {
    ...mapActions('shareholderFaq', {
      getShareholderFaq: 'findById',
      save: 'save',
    }),
    cancelHandler() {
      this.$router.push({ name: 'InvestorFAQList' });
    },
    saveHandler() {
      this.save(this.shareholderFaq).then(() => {
        this.$router.push({ name: 'InvestorFAQList' });
      });
    },
  },
};
</script>

<style></style>
